
import {
  computed,
  defineComponent,
  onBeforeMount,
  ref,
  shallowRef,
  watch,
} from "vue";
import {
  AdminTableLayout,
  DatePicker,
  ReportTable,
  DefaultOptionSelect,
} from "@/components/Common";
import { usePagination } from "@/hooks";
import moment from "dayjs";
import { getTableColumn } from "./besRechargeTableColumn";

import {
  AccountsDetail,
  EnableNetName,
  GetMerchantSheetList,
  GetMerchantSheetPhoneList,
} from "@/api-server/modules/defaultServer";
import { zcatPoint } from "@/utils/utilFuns";
import { getStoreMapWithDicKey } from "@/utils/formatter";

export default defineComponent({
  name: "BesRecharge",
  components: {
    AdminTableLayout,
    DatePicker,
    ReportTable,
    DefaultOptionSelect,
  },

  setup() {
    const partnerList = ref<{ key: string; value: string }[]>([]);
    const partnerSiteList = ref<any[]>([]);

    const formData = ref({
      partnerId: "",
      netCode: "",
      time: [
        moment().subtract(1, "month").startOf("day").format("YYYY-MM-DD"),
        moment().startOf("day").format("YYYY-MM-DD"),
      ],
      operationType: "0",
      number: "",
    });

    onBeforeMount(async () => {
      const {
        data: { data },
      } = await GetMerchantSheetList.fetch({ enable: 1, isReal: 1 });
      partnerList.value =
        data?.map((item) => {
          return {
            key: item,
            value: item,
          };
        }) || [];
      formData.value.partnerId = partnerList.value[0]?.value || "";
      await changePartnerSiteHandle(formData.value.partnerId);
      onSearchHandle();

      watch(
        () => formData.value.partnerId,
        async (partnerId) => {
          changePartnerSiteHandle(partnerId);
        }
      );
    });

    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
    } = usePagination(
      AccountsDetail.fetch,
      formData,
      (editFormData) => {
        const editFormDataValue = editFormData.value;
        return {
          ...editFormDataValue,
          startTime: moment(editFormData.value.time[0]).format("YYYYMMDD"),
          endTime: moment(editFormData.value.time[1]).format("YYYYMMDD"),
        };
      },
      {
        notMountedRequest: true,
      }
    );

    const showTableColumn = computed(() => {
      return getTableColumn(formData.value.operationType);
    });

    watch(
      () => formData.value.operationType,
      () => {
        formData.value.number = "";
        onSearchHandle();
        let operationTypeName = "";
        getStoreMapWithDicKey("partner_account").map((item) => {
          if (item.enumKey == formData.value.operationType) {
            operationTypeName = item.enumValue;
          }
        }),
          zcatPoint(["余额变化明细", operationTypeName, "操作类型"]);
      }
    );

    async function changePartnerSiteHandle(partnerId: string) {
      formData.value.netCode = "";
      if (partnerId) {
        try {
          const {
            data: { data },
          } = await EnableNetName.fetch({
            partnerId,
          });
          partnerSiteList.value = data || [];
          formData.value.netCode = partnerSiteList.value[0].siteCode || "";
        } catch (e) {
          partnerSiteList.value = [];
        }
      }
    }

    const pickMinDate = shallowRef<number | null>(null);
    function pickTimeHandler(timestemp: number) {
      if (pickMinDate.value) {
        pickMinDate.value = null;
      } else {
        pickMinDate.value = timestemp;
      }
    }

    function disabledDateHandle(time: Date) {
      const cellTime = time.getTime();
      const pickMinTime = pickMinDate.value;
      if (pickMinTime) {
        const currentTime = moment().endOf("day").valueOf();
        const rangeTime = 31 * 24 * 3600 * 1000;
        const moreThenTime = pickMinTime + rangeTime;
        const prevThenTime = pickMinTime - rangeTime;
        const endTime = currentTime > moreThenTime ? moreThenTime : currentTime;
        const startTime = prevThenTime;
        return cellTime > endTime || cellTime < startTime;
      }
      return time.getTime() > moment().endOf("day").valueOf();
    }

    return {
      partnerList,
      partnerSiteList,
      formData,
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      tableData,
      showTableColumn,
      pickTimeHandler,
      disabledDateHandle,
    };
  },
});
